module.exports = __webpack_public_path__ + "img/stock2.ae40b998.png";